import PropTypes from "prop-types";
import BlogPostMeta from "./BlogPostMeta";
import ListBlogPostsText from "./ListBlogPostsText";
import BigTitleText from "../BigTitleText";
import LikeSection from "../utils/LikeSection.jsx";
import SafeHtmlContent from "../SafeHtmlContent";
import ShareLink from "../ShareLink";

const BlogPost = ({ data }) => {
  const postedByType = String(
    data?.blogpost?.posted_by_type || "",
  ).toLowerCase();
  const postedByBasePath = ["organizer", "organiser", "organization"].includes(
    postedByType,
  )
    ? "/orgs"
    : "/music";
  const postedByUrl = data
    ? `${postedByBasePath}/${data.blogpost.posted_by_slug}`
    : "";
  const imageMainAltText = data
    ? `Heading image for /${data.blogpost.posted_by_name}`
    : "";

  return (
    <>
      {data ? (
        <>
          <div className="grid sm:grid-cols-5 gap-8 sm:p-4 px-0 py-4">
            <div className="col-span-3 flex flex-col space-y-4">
              <div>
                <div>
                  <h1 className="text-4xl sm:text-5xl font-black text-white uppercase tracking-wider leading-tight drop-shadow-md mb-2">
                    {data.blogpost.title}
                  </h1>
                </div>
                <div className="my-4 bg-[#131313] border border-white/10 rounded-2xl p-4 shadow-md text-xs text-stone-400 font-bold uppercase tracking-wider">
                  <span>{data.blogpost.post_type} av </span>
                  <a
                    href={postedByUrl}
                    className="text-white hover:text-[#0047ff] transition-colors font-extrabold"
                  >
                    {data.blogpost.posted_by_name}
                  </a>
                  <span> den </span>
                  <span className="text-stone-300 font-semibold">
                    {data.blogpost.created_at}
                  </span>
                </div>
                <div className="mb-2">
                  {data.blogpost.image_main && (
                    <div className="w-full aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-2xl border border-white/10 shadow-lg">
                      <img
                        className="w-full h-full object-cover"
                        src={data.blogpost.image_main}
                        alt={imageMainAltText}
                      />
                    </div>
                  )}
                </div>
                <div className="prose shadow-lg max-w-none w-full my-4 bg-[#131313] border border-white/10 rounded-2xl p-6 overflow-hidden break-words text-stone-300 leading-relaxed text-sm sm:text-base">
                  <SafeHtmlContent
                    html={data.blogpost.content}
                    className="prose prose-invert max-w-none break-words"
                  />
                </div>
                <div className="flex items-center justify-between flex-wrap pr-2">
                  <LikeSection likes={data.blogpost.likes} />
                  <div className="mt-4 mb-2 pt-4">
                    <ShareLink title={data.blogpost.title} />
                  </div>
                </div>
                <div className="shadow-md">
                  <BlogPostMeta data={data} />
                </div>
              </div>
            </div>
            <div className="col-span-3 sm:col-span-2 flex flex-col sm:min-h-screen space-y-4">
              <h3 className="text-xl font-extrabold text-white uppercase tracking-wider pl-1 mb-2 mt-6">
                Mer från <span className="text-[#0047ff]">{data.blogpost.posted_by_name}</span>
              </h3>
              <ListBlogPostsText
                posts={data.blogpost.other_posts_by_band}
                posted_by={data.blogpost.posted_by_name}
                posted_by_slug={data.blogpost.posted_by_slug}
                posted_by_type={data.blogpost.posted_by_type}
              />
              <div className="border-t border-white/10 my-6 py-2" />
              <h3 className="text-xl font-extrabold text-white uppercase tracking-wider pl-1 mb-2">
                Se mer från kategori <span className="text-[#0047ff]">{data.blogpost.post_type}</span>
              </h3>
              <ListBlogPostsText
                posts={data.blogpost.other_posts_by_post_type}
              />
            </div>
          </div>
        </>
      ) : (
        <div>
          <h4>Bläddrar i arkiven...</h4>
        </div>
      )}
    </>
  );
};

BlogPost.propTypes = {
  data: PropTypes.shape({
    blogpost: PropTypes.shape({
      title: PropTypes.string,
      post_type: PropTypes.string,
      posted_by_name: PropTypes.string,
      posted_by_slug: PropTypes.string,
      posted_by_type: PropTypes.string,
      created_at: PropTypes.string,
      image_main: PropTypes.string,
      content: PropTypes.string,
      likes: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.shape({
          count: PropTypes.number,
          user_has_liked: PropTypes.bool,
          object_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          object_type: PropTypes.string,
        }),
      ]),
      other_posts_by_band: PropTypes.array,
      other_posts_by_post_type: PropTypes.array,
    }),
  }),
};

export default BlogPost;
